import React, { useEffect } from "react";

const HubSpotForm = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/47653788.js";
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div>
      <div
        className="hs-form-frame"
        data-region="na1"
        data-form-id="a85342d7-3783-4fcd-bf74-f51bfe5ffdde"
        data-portal-id="47653788"
      ></div>
    </div>
  );
};

export default HubSpotForm;
